import React, { SVGProps } from "react";

const SvgAcademicCap = (props) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="svg-icon" {...props}>
    <path
      d="M16.7574 2.99666L14.7574 4.99666H5V18.9967H19V9.23931L21 7.23931V19.9967C21 20.549 20.5523 20.9967 20 20.9967H4C3.44772 20.9967 3 20.549 3 19.9967V3.99666C3 3.44438 3.44772 2.99666 4 2.99666H16.7574ZM20.4853 2.09717L21.8995 3.51138L12.7071 12.7038L11.2954 12.7063L11.2929 11.2896L20.4853 2.09717Z"
      stroke="currentColor"
    />
  </svg>
);
export default SvgAcademicCap;
